import React, { FC, ReactElement } from "react";
import { Typography } from "antd";
import { useHistory } from "react-router-dom";
import "./SliderBrands.css";

interface Brand {
  id: number;
  name: string;
  image: string;
}

interface SliderBrandsProps {
  brands: Brand[];
}

const SliderBrands: FC<SliderBrandsProps> = ({ brands }): ReactElement => {
  const history = useHistory();

  const handleBrandClick = (brandName: string) => {
    const encoded = encodeURIComponent(brandName);
    history.push(`/menu?brand=${encoded}`);
  };

  return (
    <div className="brands-wrapper">
      <Typography.Title level={3} className="brands-wrapper-title">
        Top Brands
      </Typography.Title>

      <div className="brands-grid">
        {brands.map((brand) => (
          <div
            key={brand.id}
            className="brand-card"
            onClick={() => handleBrandClick(brand.name)}
          >
            <div className="brand-logo-container">
              <img
                src={brand.image}
                alt={brand.name}
                className="brand-image"
                loading="lazy"
              />
            </div>
            <Typography.Text className="brand-name">
              {brand.name}
            </Typography.Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderBrands;
